import { Component } from '@angular/core';
import { OfficeTemplatesService } from './services/office-templates.service';
import { StandardAssembly } from 'src/app/models/standard-template.model';
import { Assembly } from 'src/app/models/assembly.model';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { OfficeTemplatesAssembliesService } from './services/office-templates-assemblies.service';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { TemplateFilterComponent } from './template-filter/template-filter.component';
import { OpsAssemblyEditorComponent } from '../assemblies/assembly-editor/assembly-editor.component';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { AssembliesService } from '@/services/api/assemblies.service';

@Component({
    selector: 'app-office-templates',
    imports: [
        CommonModule,
        ToastModule,
        ContextMenuModule,
        TableModule,
        DialogModule,
        TemplateFilterComponent,
        OpsAssemblyEditorComponent,
        ButtonModule,
        FormsModule
    ],
    template: `
    <div class="component-content" style="height: 100%; display: flex; flex-direction: column;">
    <div class="mb-2">
        <app-template-filter></app-template-filter>
    </div>
    <p-toast></p-toast>
    <p-contextMenu #cm [model]="menuItems" />
    <div class="surface-card shadow-2 border-round p-2" style="flex: 1; display: flex; overflow: hidden; max-height: calc(90vh - 180px);">
        <div #assembliesContainer class="assemblies" style="flex: 2; overflow-y: auto; max-height: 100%;">
            <p-table 
    [value]="getAssemblies()" 
    dataKey="Assemblies.AID" 
    [contextMenu]="cm" 
    [(contextMenuSelection)]="selectedAssembly" 
    pContextMenuRowIndex="rowIndex"
    rowGroupMode="subheader" 
    groupRowsBy="Assemblies.Categories.Name" 
    styleClass="p-datatable-sm"
    [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Type</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="groupheader" let-assembly let-rowIndex="rowIndex" let-expanded="expanded">
            <tr>
                <td colspan="4">
                    <span class="font-bold ml-2">{{assembly.Assemblies.Categories.Name}}</span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-assembly>
            <tr [pSelectableRow]="assembly" [pContextMenuRow]="assembly">
                <td>{{assembly.Assemblies.Name}}</td>
                <td [innerHTML]="assembly.Assemblies.Description"></td>
                <td><input type="number" *ngIf="assembly.Assemblies.Type === 'O'" [(ngModel)]="assembly.quantity" (ngModelChange)="updateAssemblyQuantity(assembly, $event)" /></td>
                <td><p-button class="m-0" icon="pi pi-trash" severity="danger" [rounded]="true" [text]="true" [style]="{'margin-right': '.25em'}" size="small" (onClick)="confirmDeleteAssembly(assembly)"/></td>
            </tr>
        </ng-template>
</p-table>
        </div>
      </div>
    </div>
    <!-- <p-dialog class="w-full md:w-10 lg:w-8 xl:w-6" header="Edit Assembly" [modal]="true" [draggable]="false" [resizable]="false" [(visible)]="addAssemblyVisible" [style]="{ 'max-height': '90vh', 'overflowY': 'auto' }">
    </p-dialog> -->
    <p-dialog class="w-full md:w-10 lg:w-8 xl:w-6" header="Edit Assembly" [modal]="true" [draggable]="false" [resizable]="false" [(visible)]="editAssemblyVisible" [style]="{ 'max-height': '90vh', 'overflowY': 'auto' }">
        <app-assembly-editor [templateMode]="true" (save)="onSaveAssembly($event)"></app-assembly-editor>
    </p-dialog>
    `
})
export class OfficeTemplatesComponent {
  addAssemblyVisible = false;
  editAssemblyVisible = false;
  menuItems: MenuItem[] = [];
  selectedAssembly: StandardAssembly | null = null;

  constructor(
    public officeTemplatesService: OfficeTemplatesService,
    public assemblyService: AssembliesService,
    private messageService: MessageService,
    private officeTemplatesAssemblyService: OfficeTemplatesAssembliesService,
    private confirmationService: ConfirmationService
  ) {
    this.menuItems = [
      { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: () => this.editAssembly(this.selectedAssembly?.Assemblies) },
      { label: 'Delete', icon: 'pi pi-fw pi-times', command: () => this.deleteAssembly(this.selectedAssembly) }
  ];
   }

  getAssemblies() {
    if(this.officeTemplatesService.selectedTemplate()) {
      return this.officeTemplatesService.selectedTemplate()?.StandardAssemblies || [];
    }
    return [];
  }

  editAssembly(assembly: Assembly | null | undefined) {
    if(assembly) {
      this.assemblyService.setSelectedAssembly(assembly);
      this.editAssemblyVisible = true;
      console.log('editing assembly', assembly);
    }
  }

  deleteAssembly(assembly: StandardAssembly | null | undefined) {
    if(assembly) {
      console.log('deleting assembly', assembly);
      this.officeTemplatesAssemblyService.removeAssembly(assembly);
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assembly deleted' });
    }
  }

  onSaveAssembly(assembly: Assembly) {
    console.log('saving assembly', assembly);
    this.officeTemplatesService.updateTemplateAssembly(assembly);
  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assembly saved' });
  this.editAssemblyVisible = false;
  }

  updateAssemblyQuantity(assembly: StandardAssembly, quantity: number) {
    this.officeTemplatesAssemblyService.updateAssemblyQuantity(assembly, quantity);
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assembly quantity updated' });
  }

  confirmDeleteAssembly(assembly: StandardAssembly) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this assembly?',
      accept: () => this.deleteAssembly(assembly)
    });
  }

}
